// Mirrors the server matcher's normalization exactly (dailybreak-api
// src/main/java/com/dailybreak/util/ProductScanMatcher.java#normalizeScannedCode, which itself
// wraps ProductTaxonomyValidator.normalizeIdentifier): strip to digits, reject anything longer
// than a GTIN-14 as unreadable/garbled, then zero-pad to 14. UPC-A (12), UPC-E (6/8 — the
// BarcodeDetector/ZXing decoders already expand this to the 12-digit UPC-A form), EAN-13 (13)
// and GTIN-14 (14) all land on the same 14-digit key this way.
const GTIN_LENGTH = 14

export const normalizeScannedCode = (scanned: string | null | undefined): string | null => {
  if (!scanned) return null
  const digits = scanned.replace(/\D/g, '')
  if (!digits || digits.length > GTIN_LENGTH) return null
  return digits.padStart(GTIN_LENGTH, '0')
}
